// Loading.jsx
import React from "react";
import "./Loading.css";

const Loading = () => (
  <div id="spinner-wrapper">
    <div id="spinner" className="spinner-border text-primary" role="status" />
    <span className="visually-hidden">Loading...</span>
  </div>
);

export default Loading;
